/* Barra fija de compra global.
   Sale al bajar la página, añade al carrito sin recargar y abre el carrito
   lateral. Si algo falla, manda al visitante a la página del producto. */
(function () {
  'use strict';

  function init() {
    var barra = document.querySelector('.fe-bc');
    if (!barra) return;

    var boton = barra.querySelector('.fe-bc__boton');
    var disparo = parseInt(barra.getAttribute('data-disparo'), 10) || 600;
    var urlProducto = barra.getAttribute('data-url') || '';
    var varianteId = barra.getAttribute('data-variante') || '';
    var cantidad = parseInt(barra.getAttribute('data-cantidad'), 10) || 1;

    document.body.classList.add('fe-bc-activa');

    // Visibilidad: aparece pasado el umbral y se esconde cerca del pie para no
    // pisar el propio botón de compra que haya al final.
    function revisa() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var restante = document.documentElement.scrollHeight - y - window.innerHeight;
      var visible = y > disparo && restante > 120;
      barra.classList.toggle('fe-bc--visible', visible);
      barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    window.addEventListener('scroll', revisa, { passive: true });
    window.addEventListener('resize', revisa);
    revisa();

    if (!boton) return;

    boton.addEventListener('click', function () {
      var caja = barra;
      var id = caja.getAttribute('data-variante') || varianteId;
      var qty = caja.getAttribute('data-cantidad') || cantidad;

      if (typeof window.__feCartDispara === 'function' && id) {
        window.__feCartDispara({ id: id, quantity: qty, boton: boton });
        return;
      }

      var cajon = document.querySelector('cart-drawer');
      var puedeAjax = id &&
        window.routes && window.routes.cart_add_url &&
        cajon && typeof cajon.renderContents === 'function';

      if (!puedeAjax) {
        if (urlProducto) window.location.href = urlProducto;
        return;
      }

      boton.setAttribute('aria-busy', 'true');

      var datos = new FormData();
      datos.append('id', id);
      datos.append('quantity', qty);
      try {
        var secciones = cajon.getSectionsToRender().map(function (s) { return s.id; });
        datos.append('sections', secciones);
        datos.append('sections_url', window.location.pathname);
      } catch (e) {}

      cajon.classList.remove('is-empty');

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: datos
      })
        .then(function (r) { return r.json(); })
        .then(function (respuesta) {
          if (respuesta.status) {
            if (urlProducto) window.location.href = urlProducto;
            return;
          }
          cajon.renderContents(respuesta);
          barra.classList.add('fe-bc--anadido');
          setTimeout(function () { barra.classList.remove('fe-bc--anadido'); }, 2200);
        })
        .catch(function () {
          if (urlProducto) window.location.href = urlProducto;
        })
        .then(function () {
          boton.removeAttribute('aria-busy');
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga la sección al vuelo.
  document.addEventListener('shopify:section:load', init);
})();
